import React, { useState } from "react";
import logo from "../images/familee_tree_logo.svg";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { forgotResetPassword } from "../services/ApiServices";

const validate = (values) => {

  const errors = {};
  if (!values.newPassword) {
    errors.newPassword = "Please enter your new password.";
  } else if (values.newPassword.length < 6) {
    errors.newPassword = "New password must be at least 6 characters.";
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = "Please confirm your new password.";
  } else if (values.confirmPassword !== values.newPassword) {
    errors.confirmPassword = "Passwords must match.";
  }

  return errors;
};

export const ForgotPassword = ({ emailId }) => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const formik = useFormik({
    initialValues: { newPassword: "", confirmPassword: "" },
    validate,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const payload = { emailId: emailId, password: values.newPassword }
        const resetForgotPass = await forgotResetPassword(payload);
        if(resetForgotPass.status === 200) {
            toast.success(resetForgotPass.data.message)
            window.location.href = "/";
        }

      } catch (error) {
        toast.error(error.response.data.message);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <React.Fragment>
                  <div className="login-page">
            <div className="login-container">
              <img src={logo} alt="FamileeTree" className="logo" />
      <div className="forgot-password-body">
        <div className="forgot-password">
          <form onSubmit={formik.handleSubmit}>
            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <div className="hideShow-input">
                <div className="password-input">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    id="newPassword"
                    name="newPassword"
                    value={formik.values.newPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div
                  className="show-hide-password"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? (
                   <FontAwesomeIcon icon={faEye} /> 
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </div>
              </div>
              {formik.touched.newPassword && formik.errors.newPassword ? (
                <p className="error-message">{formik.errors.newPassword}</p>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <div className="hideShow-input">
                <div className="password-input">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div
                  className="show-hide-password"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <FontAwesomeIcon icon={faEye} />
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </div>
              </div>
              {formik.touched.confirmPassword &&
              formik.errors.confirmPassword ? (
                <p className="error-message">{formik.errors.confirmPassword}</p>
              ) : null}
            </div>
            <button type="submit">Change Password</button>
          </form>
        </div>
        </div>
        </div>
      </div>
    </React.Fragment>
  );
};
